import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const DairyPlants: React.FC = () => {
  return (
    <>
      <PageHeader title="Dairy Plants" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Dairy Plants</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Dairy processing requires a delicate balance of hygiene, efficiency, and temperature control. At Wasser Technochem (India) Ltd., we offer specialized services in the supply and installation of key dairy processing equipment, utilities, and support systems — tailored to the needs of small, medium, and large-scale dairies.</p>
              <p>We ensure high-quality equipment installation that adheres to FSSAI, BIS, and GMP standards, while maintaining clean-in-place (CIP) compatibility and automation readiness.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-thermometer-half text-primary me-2"></i>Milk chilling & pasteurization units</p>
              <p><i className="fa fa-layer-group text-primary me-2"></i>Cream separation and homogenization systems</p>
              <p><i className="fa fa-cheese text-primary me-2"></i>Ghee, curd, paneer, and lassi lines</p>
              <p><i className="fa fa-cogs text-primary me-2"></i>Utility piping for steam, chilled water, and compressed air</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>CIP system installation</p>
              <p><i className="fa fa-water text-primary me-2"></i>Process water and treated effluent integration</p>

              <h3 className="mb-4">Our Capabilities</h3>
              
              <h4 className="mb-3"><i className="fa fa-tools text-primary me-2"></i>Supply & Installation of Process Equipment:</h4>
              <p>Pasteurizers, homogenizers, storage tanks, plate heat exchangers, etc.</p>

              <h4 className="mb-3"><i className="fa fa-wrench text-primary me-2"></i>SS316L Piping & Structural Fabrication:</h4>
              <p>For milk and product lines with sanitary welding (orbital TIG welding)</p>

              <h4 className="mb-3"><i className="fa fa-link text-primary me-2"></i>Utility Integration:</h4>
              <p>Steam, RO water, hot water, refrigeration, and effluent discharge systems</p>

              <h4 className="mb-3"><i className="fa fa-microchip text-primary me-2"></i>Automation-Ready Skid Mounting:</h4>
              <p>Including control valves, flow meters, RTDs, and PLC interfaces</p>

              <h4 className="mb-3"><i className="fa fa-file-alt text-primary me-2"></i>Documentation & Testing:</h4>
              <p>Installation manuals, P&IDs, FAT/SAT, and commissioning support</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Fast-track installation with minimal downtime</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compliance with food-grade and sanitary standards</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Modular setup for future scalability</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Seamless integration with utilities and water treatment</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Designed for ease of operation and CIP sanitation</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Proven experience in Rajasthan Dairy (Saras milk) and beverage industry utilities</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house fabrication and installation teams for SS process lines</p>
              <p><i className="fa fa-star text-warning me-2"></i>Strong coordination with OEM suppliers and automation vendors</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Ability to integrate with water, wastewater, and steam systems</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default DairyPlants;
